<template>
  <div class="h-100 d-flex justify-content-center align-items-center">
    <div class="modern-spinner"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
/* Modern CSS spinner */
.modern-spinner {
  width: 64px;
  height: 64px;
  border: 8px solid #e0e0e0;
  border-top: 8px solid #337cc5;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
